import { Controller } from "@hotwired/stimulus"

const DOMAIN = "flight13.com"

export default class extends Controller {
  static values = {
    user:    String,     // e.g. "info", "jobs", "hello"
    subject: String,     // optional subject line
    body:    String,     // optional email body
    classes: String,     // additional classes for the <a> tag
    plain:   Boolean     // if true → plain text only, no <a> link
  }

  connect() {
    if (!this.userValue) {
      console.warn("mailto controller: missing data-mailto-user-value", this.element)
      return
    }

    const email = `${this.userValue}@${DOMAIN}`
    const subject = this.hasSubjectValue ? this.subjectValue : ""
    const mailtoUrl = subject
	  ? `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(this.bodyValue)}`
	  : `mailto:${email}`


    if (this.plainValue) {
      // Replace the span with plain text (still protected)
      this.replaceWithText(email)
    } else {
      // Replace content with clickable mailto link
      const link = document.createElement("a")
      link.href = mailtoUrl
      link.classList.add("mailto-link")
      link.className = this.hasClassesValue ? this.classesValue : ""
      link.innerHTML = this.element.innerHTML
      // Replace any placeholder with real email (useful for visible text)
      link.innerHTML = link.innerHTML.replace(/EMAIL/g, email)

      this.element.replaceWith(link)
    }
  }

  // Helper: replace current element with plain text node
  replaceWithText(text) {
    const textNode = document.createTextNode(text)
    this.element.replaceWith(textNode)
  }
}
